<mat-form-field
  [appearance]="appearance"
  class="fk-w-full"
  [ngClass]="{ 'fk-dir-ltr': isLtr, 'fk-dir-rtl': !isLtr }"
>
  <!-- label -->
  <mat-label>
    <base-form-kit-label [label]="label">
      <ng-content select="[label-content]"></ng-content>
    </base-form-kit-label>
  </mat-label>

  <mat-select
    #matSelect
    panelClass="select-search"
    [disabled]="isDisabled"
    [(ngModel)]="values"
    (selectionChange)="emitValues(values)"
    [formControl]="control || defaultControl"
    [ngClass]="matSelectPadding"
    multiple
    (openedChange)="checkIsOpened($event)"
    (infiniteScroll)="getNextItems()"
    msInfiniteScroll
  >
    <mat-select-trigger>
      <mat-chip-grid class="fk-px-10px" *ngIf="!isUseApiFilter">
        <mat-chip-row
          *ngFor="let item of selectedItems"
          [removable]="true"
          (removed)="onSelectedItemsRemoved(item)"
        >
          <span [ngClass]="isLtr ? 'fk-dir-ltr' : ''">
            {{ item[optionTitle] }}</span
          >
          <mat-icon class="dark:tw-text-gray-400" matChipRemove
            >cancel</mat-icon
          >
        </mat-chip-row>
      </mat-chip-grid>
    </mat-select-trigger>

    <mat-option>
      <ngx-mat-select-search
        class="fk-dir-rtl"
        [formControl]="filterControl"
        [placeholderLabel]="placeholder | translate"
        [noEntriesFoundLabel]="'common.empty' | translate"
      >
        <div ngxMatSelectSearchClear class="fk-text-2xl">×</div>
      </ngx-mat-select-search>
    </mat-option>

    <!--select all option-->
    <mat-option
      #matSelectAll
      *ngIf="isShowSelectAll && items?.length > 0"
      (onSelectionChange)="selectAll($event)"
    >
      <span
        [innerHTML]="'common.all' | translate"
        [ngClass]="isLtr ? 'fk-dir-ltr fk-block' : ''"
      ></span>
    </mat-option>

    <mat-option
      #matOption
      *ngFor="
        let item of filteredItems
          | async
          | removeSelectedItems : selectedItems : isUseApiFilter
      "
      [value]="item[optionValue]"
      (onSelectionChange)="emitItems(item, $event, matOption)"
    >
      <span
        [innerHTML]="item[optionTitle]"
        [ngClass]="isLtr ? 'fk-dir-ltr fk-block' : ''"
      ></span>
    </mat-option>

    <mat-option class="empty-chip fk-dir-rtl" *ngIf="this.items?.length == 0">
      <span> {{ "common.empty" | translate }} </span>
    </mat-option>
  </mat-select>

  <!-- init loading -->
  <mat-icon
    matSuffix
    class="fk-absolute fk-left-5 fk-text-primary fk-flex-around"
    *ngIf="loading"
  >
    <span
      class="fk-spinner-border fk-spinner-border-sm"
      role="status"
      aria-hidden="true"
    ></span>
    <span class="sr-only">Loading...</span>
  </mat-icon>

  <!-- clear btn -->
  <mat-icon
    class="fk-absolute fk-left-4 fk-text-gray fk-px-2 fk-z-10"
    [matTooltip]="'common.removeAll' | translate"
    *ngIf="
      this.values?.length &&
      !isDisabled &&
      !initLoading &&
      isShowDeleteBtn &&
      items?.length
    "
    (click)="clear()"
  >
    delete_forever
  </mat-icon>
</mat-form-field>
